// Mono icons ("copy"), https://github.com/mono-company/mono-icons -- public domain.
//
// Redrawn as strokes rather than kept as the source's filled compound path. That
// path draws each square as a solid frame with a hole punched in it, so its
// weight is baked into the geometry and cannot be thinned -- as a stroke the
// same two squares take strokeWidth, which is what makes this light enough to
// sit beside the other 14px icons in the sidebar.
//
// Same composition as the original: a back square up-left, clipped where the
// front one overlaps it. strokeWidth is deliberately 1.5, not 2.
export const CopyFileIcon = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Front square, bottom-right. */}
    <rect height={12} rx={2} width={12} x={9} y={9} />
    {/* Back square, drawn only where the front one does not cover it. */}
    <path d="M15 9V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4" />
  </svg>
);
